import { Box, Grid, GridItem, useColorModeValue } from "@chakra-ui/react";
import { useEffect } from "react";
import { useImportRoster } from "../../hooks/useImportRoster";
import { importService } from "../../services/importMockService";
import RosterHistorySection from "./RosterHistorySection";
import StepAnalyzing from "./StepAnalyzing";
import StepDone from "./StepDone";
import StepMappingReview from "./StepMappingReview";
import StepperHeader from "./StepperHeader";
import StepProcessing from "./StepProcessing";
import StepUpload from "./StepUpload";

export default function ImportRosterMainPage() {
  const {
    step,
    file,
    mappingResult,
    uploadFile,
    startImport,
    reset,
    goToUpload,
    setStep,
    importId,
    setImportId,
    isLoading,
    getRostersHistory,
    importHistory,
    historyLoading,
    getRosterImportResults,
    setMappingResult,
    deleteHistoryItem,
    updateHistoryItem,
  } = useImportRoster();

  const cardBg = useColorModeValue("white", "gray.800");

  useEffect(() => {
    getRostersHistory();
  }, [getRostersHistory]);

  const handleHistorySelect = async (roster, targetStep) => {
    setImportId(roster.import_id);

    if (targetStep === "MAPPING_REVIEW") {
      try {
        const mapping = await importService.validateRoster(roster.import_id);
        setMappingResult(mapping);
      } catch (err) {
        console.error("Failed to load mapping for history item:", err);
      }
    }

    setStep(targetStep);
  };

  return (
    <Box>
      <Grid templateColumns={{ base: "1fr", md: "1fr 500px" }} gap={6} px={4}>
        <GridItem>
          <StepperHeader step={step} />

          <Box
            bg={cardBg}
            p={2}
            borderRadius="2xl"
            boxShadow="0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)"
            border="1px solid"
            borderColor={useColorModeValue("gray.100", "gray.700")}
          >
            {step === "UPLOAD" && (
              <StepUpload onUpload={uploadFile} isLoading={isLoading} />
            )}

            {step === "ANALYZING" && <StepAnalyzing />}

            {step === "MAPPING_REVIEW" && (
              <StepMappingReview
                file={file}
                mappingResult={mappingResult}
                onConfirm={startImport}
                onBack={goToUpload}
                importId={importId}
                setStep={setStep}
                deleteImport={deleteHistoryItem}
                startImport={startImport}
              />
            )}

            {step === "PROCESSING" && (
              <StepProcessing
                setStep={setStep}
                importId={importId}
                getRosterImportResults={getRosterImportResults}
                updateHistoryItem={updateHistoryItem}
                onComplete={getRostersHistory}
                onBack={() => setStep("MAPPING_REVIEW")}
              />
            )}

            {step === "DONE" && (
              <StepDone
                onReset={reset}
                importId={importId}
                getRosterImportResults={getRosterImportResults}
              />
            )}
          </Box>
        </GridItem>

        <GridItem>
          <RosterHistorySection
            importHistory={importHistory}
            isLoading={historyLoading}
            deleteHistoryItem={deleteHistoryItem}
            onSelect={handleHistorySelect}
          />
        </GridItem>
      </Grid>
    </Box>
  );
}
